import { initContactPanel, initContactFormValidation } from "./contact.js";
import { initPolygons } from "./svg-morph.js";
import { initScrollSlider } from "./slider.js";
import { initSmoothScroll } from "./scroll.js";
import { initStickyNav } from "./nav.js";

document.addEventListener('DOMContentLoaded', function() {
  initStickyNav();
  initContactPanel();
  initContactFormValidation();
  initSmoothScroll();
  initPolygons();
  initScrollSlider();
});
